import type { EventEmitterUtil } from '@chesscom/web-ui';

export namespace Plugins {
  export interface API<T, U> extends EventEmitterUtil.EventEmitter {
    add: (plugin: Plugins.Model<T, U>) => boolean;
    addMany: (plugins: Plugins.Model<T, U>[]) => boolean;
    destroy: () => void;
    getAll: () => Plugins.Model<T, U>[];
    getContext(): U | undefined;
    getOne: (key: string) => Plugins.Model<T, U> | undefined;
    has: (name: string) => boolean;
    remove: (key: string) => boolean;
    setContext: (newContext: U) => void;
  }

  export enum Events {
    PluginAdded = 'PluginAdded',
    PluginRemoved = 'PluginRemoved',
    ContextSet = 'ContextSet',
  }

  export type Model<T, U> = {
    create?: (context?: U) => void;
    destroy?: (context?: U) => void;
    name: string;
  } & T;
}
